import React from 'react';
import { Route, Switch } from 'react-router-dom';
import CachedResponse from '../common/CachedResponse';
import NotFound from '../NotFound';
import CreateForm from './CreateForm';
import EditForm from './EditForm';
import InstallerReport from './InstallerReport';
import MakeReadyReport from './MakeReadyReport';
import SearchPage from './Search';
import WalkthroughReport from './WalkThroughReport';
import {
  ROLE_ADMIN,
  ROLE_INSTALLER,
  ROLE_INVENTORY_MANAGER,
  ROLE_SALES,
  ROLE_SALES_AND_INVENTORY_MANAGER,
  ROLE_SALES_MANAGER,
  ROLE_SERVICE,
  ROLE_SUPER_ADMIN,
  ROLE_TECH
} from '../../helpers/constants';
import { isAdmin, userHasAnyRole } from '../../helpers/roleHelpers';

const Contract = () => {
  const getActivePage = () => {
    return (
      <Switch>
        <Route exact path="/contract/search">
          <CachedResponse listEndpoint={'app-choices'} render={appChoices => <SearchPage appChoices={appChoices} />} />
        </Route>
        {isAdmin() && (
          <Route exact path="/contract/create">
            <CachedResponse
              listEndpoint={'app-choices'}
              render={appChoices => <CreateForm appChoices={appChoices} />}
            />
          </Route>
        )}
        <Route exact path="/contract/:id">
          <CachedResponse listEndpoint={'app-choices'} render={appChoices => <EditForm appChoices={appChoices} />} />
        </Route>
        <Route exact path="/contract/:id/report/walkthrough">
          <WalkthroughReport />
        </Route>
        <Route exact path="/contract/:id/report/makeReady">
          <MakeReadyReport />
        </Route>
        <Route exact path="/contract/:id/report/installer">
          <InstallerReport />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    );
  };

  const hasInventoryManager = userHasAnyRole(ROLE_INVENTORY_MANAGER);
  const hasOtherContractAccess = userHasAnyRole(
    ROLE_SUPER_ADMIN,
    ROLE_ADMIN,
    ROLE_SALES,
    ROLE_SALES_MANAGER,
    ROLE_SALES_AND_INVENTORY_MANAGER,
    ROLE_SERVICE,
    ROLE_INSTALLER,
    ROLE_TECH
  );
  if (hasInventoryManager && !hasOtherContractAccess) {
    return <NotFound text="You are not authorized to view this page" />;
  }

  return getActivePage();
};

export default Contract;
